import { useEffect } from "react";
import { useHistory } from "react-router";

import useIsMounted from "../useIsMounted";
import { ICustomCssModelv1 } from "api/files";
import { useDispatch, useSelector } from "react-redux";
import { GlobalApplicationState } from "globalApplicationState";
import { GLOBAL_LAYOUT_STATUS, fetchCustomCssFileAsync } from "modules/globalLayout/reducer";
import { getExpiryFromSasUrl } from "utils/urlUtils";

type UseCustomTinyMceCssContentReturnType = {
    customCss?: ICustomCssModelv1;
    fetching: boolean;
}

interface IUseCustomTinyMceCssContentProps {
    enabled: boolean;
    tenantId: string;
}

/**
 * Wrap logic for interacting with custom css file in redux
 * @param enabled - tenant setting is enabled for this feature - tinyMceCustomCssEnabled
 * @returns UseCustomTinyMceCssContentReturnType
 */
export const useCustomTinyMceCssContent = ({ enabled, tenantId }: IUseCustomTinyMceCssContentProps): UseCustomTinyMceCssContentReturnType => {
    const isMounted = useIsMounted();
    const { customCss, status } = useSelector((state: GlobalApplicationState) => state.globalLayout);
    const fetching = status === GLOBAL_LAYOUT_STATUS.FETCHING;
    const dispatch = useDispatch();
    const { location: { pathname } } = useHistory();

    useEffect(() => {
        // check if the sas url has expired
        const isExpired = (): boolean => {
            let result = false;

            if (customCss && customCss.sasUrl) {
                let utcExpiry = getExpiryFromSasUrl(customCss.sasUrl);

                if (utcExpiry)
                    result = utcExpiry.getTime() < Date.now();
            }

            return result;
        }

        if ((!customCss || isExpired()) && enabled && !fetching)
            dispatch(fetchCustomCssFileAsync({ tenantId, admin: pathname.includes("/admin/") }));
    }, [customCss, fetching, pathname, isMounted, enabled, tenantId, dispatch]);

    return {
        customCss,
        fetching
    };
}
